import type { Observable as ObservableType } from 'rxjs/Observable';
import { fetchJson$ } from '@atlassian/jira-fetch';
import type { Permission } from '../../model/types';
import type { PermissionResponse } from './types';

export function fetchPermissions(
	boardId: string,
	permissions: Permission[] = [],
): ObservableType<PermissionResponse> {
	return fetchJson$(
		`/rest/greenhopper/1.0/xboard/permissions?boardId=${boardId}&permissions=${permissions.join(
			',',
		)}`,
	);
}
